import React from 'react'
import { Box } from '@mui/system'
import IconButton from '@mui/material/IconButton';
import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import IImage from './IImage';

interface Props {
    setFullscreenMode: () => void;
    images: IImage[];
    currentImage: number;
    onNextImage: () => void;
    onBeforeImage: () => void;
};

const PortfolioModalFullScreen: React.FunctionComponent<Props> = ({ images, currentImage, setFullscreenMode, onNextImage, onBeforeImage }) => {

    const { apiUrl } = window.appConfig;

    const styleFullscreenModal = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: '100%',
        maxHeight: 'calc(100% - 20px)',
        maxWidth: 'calc(100% - 20px)',
        boxShadow: 24
    }

    const navigateIconsStyle = {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: '#ffffff',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        padding: '5px',
        '&:hover': {
            bgcolor: 'primary.light'
        }
    }

    return (
        <Box
            sx={styleFullscreenModal}
        >
            <Box component="img"
                sx={{
                    objectFit: 'contain',
                    borderRadius: '4px',
                    height: '100%',
                }}
                src={`${apiUrl}/file/${images[currentImage].reference}`}
            >
            </Box>

            <IconButton
                onClick={() => { setFullscreenMode(false) }}
                aria-label="fullscreen-exit"
                sx={{
                    position: 'absolute',
                    top: '13px',
                    left: '13px',
                    p: 0
                }}>
                <FullscreenExitIcon
                    sx={{
                        color: '#ffffff',
                        height: '30px',
                        width: '30px',
                        '&:hover': {
                            color: 'primary.light'
                        }
                    }} />
            </IconButton>

            <IconButton
                onClick={onBeforeImage}
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: 15,
                }}
            >
                <NavigateBefore
                    sx={navigateIconsStyle} />
            </IconButton>

            <IconButton
                onClick={onNextImage}
                sx={{
                    position: 'absolute',
                    top: '50%',
                    right: 15,
                }}
            >
                <NavigateNext
                    sx={navigateIconsStyle} />
            </IconButton>
        </Box>
    )
}

export default PortfolioModalFullScreen